import { type InfiniteData } from '@tanstack/react-query';
import { flatMap } from 'lodash';

import { type LibraryListResponse } from '@air/api';

export const formatLibrariesListResponse = (data: InfiniteData<LibraryListResponse> | undefined) => {
  return {
    libraries: flatMap(data?.pages, (page) => page.data),
    librariesTotal: data?.pages?.[0]?.total,
  };
};
